import "./BrowardCountyHomeInspector.module.css";
import Header from "@/reusable_sections/Header";
import CableTraysAndConnectors from "./sections/CableTraysAndConnectors";
import Loyal2SoilPhilosophy from "./sections/Loyal2SoilPhilosophy";
import ServiceAreasPreview from "./sections/ServiceAreasPreview";
import ReadyToGrowYourRestaurant from "./sections/ReadyToGrowYourRestaurant";
import Footer from "@/reusable_sections/Footer";
export default function BrowardCountyHomeInspectorPage() {
  return <div>
      <Header />
      <CableTraysAndConnectors />
      <Loyal2SoilPhilosophy />
      <ServiceAreasPreview />
      <ReadyToGrowYourRestaurant />
      <Footer />
    </div>;
}